const formatRate = (rate) => {
  if (!rate) return "";
  const er = rate.toString().split(".");
  if (!er[1]) return rate;
  er[1] = er[1].slice(0, 3);
  return er.join(".");
};

export default formatRate;
